/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TrainIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABA0lEQVR4nO2VPW4CQQyFp4ICuAxFkAKUSFusfxJpsFfiIiQHYHODHCRtGhoOkDOEQ5BEi4YECmDwjqCCWHKxmrfv85vC49xVlfe+gSwvQLJE1iqlgeUTWcvgEQUEQaoxHnYZBfxNURHJfWSAKvSxs5yLwTbJqQRRg0uc/wPcDV1RzsUg1YBIhrUB57a7fgCwTkejSQtInuwld6g1Ad779uYbsWMBjmnNZRemCT8iy7OZYE9rLbuz1zWQzowHR8ttkiTjOg/OLglqD0i/kfWLubiL6fKHcRdIVkDyA4/jvmm8A5B+mHHdbwXNJgXpIgEg78A6z7KsaWmDBkjegOW1NuCStQbNFcoIaq7RCAAAAABJRU5ErkJggg==)
 */
export const TrainIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M3 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-.13l.96 1.45a1 1 0 0 1-1.66 1.1L15.47 20H8.53l-1.7 2.55a1 1 0 0 1-1.67-1.1L6.13 20H6a3 3 0 0 1-3-3V5Zm5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm9.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5 5a1 1 0 0 1 1-1h5v8H6a1 1 0 0 1-1-1V5Zm8 7h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-5v8Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
